import React from 'react';
import PropTypes from 'prop-types'

const ResetButton = ({ title = 'Reset', ...props}) => {
  return (
    <button
      type="button"
      className="form-wizard-action btn btn-light"
      {...props}
    >
      {title === 'Reset'
        ? <i className="fas fa-ban fs-4 me-2"/>
        : <i className="fas fa-file fs-4 me-2"/>
      }
      {title}
    </button>
  )
}

ResetButton.propTypes = {
  title: PropTypes.string,
}

export default ResetButton